import _defineProperty from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { microTask as i } from './micro-task.js';
function o() {
  var n = [],
    r = {
      addEventListener: function addEventListener(e, t, s, a) {
        return e.addEventListener(t, s, a), r.add(function () {
          return e.removeEventListener(t, s, a);
        });
      },
      requestAnimationFrame: function (_requestAnimationFrame) {
        function requestAnimationFrame() {
          return _requestAnimationFrame.apply(this, arguments);
        }
        requestAnimationFrame.toString = function () {
          return _requestAnimationFrame.toString();
        };
        return requestAnimationFrame;
      }(function () {
        var t = requestAnimationFrame.apply(void 0, arguments);
        return r.add(function () {
          return cancelAnimationFrame(t);
        });
      }),
      nextFrame: function nextFrame() {
        for (var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++) {
          e[_key] = arguments[_key];
        }
        return r.requestAnimationFrame(function () {
          return r.requestAnimationFrame.apply(r, e);
        });
      },
      setTimeout: function (_setTimeout) {
        function setTimeout() {
          return _setTimeout.apply(this, arguments);
        }
        setTimeout.toString = function () {
          return _setTimeout.toString();
        };
        return setTimeout;
      }(function () {
        var t = setTimeout.apply(void 0, arguments);
        return r.add(function () {
          return clearTimeout(t);
        });
      }),
      microTask: function microTask() {
        for (var _len2 = arguments.length, e = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          e[_key2] = arguments[_key2];
        }
        var t = {
          current: !0
        };
        return i(function () {
          t.current && e[0]();
        }), r.add(function () {
          t.current = !1;
        });
      },
      style: function style(e, t, s) {
        var a = e.style.getPropertyValue(t);
        return Object.assign(e.style, _defineProperty({}, t, s)), this.add(function () {
          Object.assign(e.style, _defineProperty({}, t, a));
        });
      },
      group: function group(e) {
        var t = o();
        return e(t), this.add(function () {
          return t.dispose();
        });
      },
      add: function add(e) {
        return n.includes(e) || n.push(e), function () {
          var t = n.indexOf(e);
          if (t >= 0) {
            var _iterator = _createForOfIteratorHelper(n.splice(t, 1)),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var s = _step.value;
                s();
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        };
      },
      dispose: function dispose() {
        var _iterator2 = _createForOfIteratorHelper(n.splice(0)),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var e = _step2.value;
            e();
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    };
  return r;
}
export { o as disposables };